import { get } from "lodash";
import { FIELDS_FOR_LISTING_PAGE, FIELDS_FOR_STORY_PAGE } from "./constants";

export function fetchLatestStories(pageNumber, perPage, params = {}) {
  return global
    .wretch("/api/v1/stories")
    .query({
      fields: FIELDS_FOR_STORY_PAGE,
      limit: perPage,
      offset: perPage * pageNumber,
      ...params
    })
    .get()
    .json();
}

export function fetchCollection(collectionSlug, pageNumber, perPage, params) {
  if (!collectionSlug) {
    return;
  }

  return global
    .wretch(`/api/v1/collections/${collectionSlug}`)
    .query({
      limit: perPage,
      "item-type": "story",
      offset: perPage * pageNumber,
      ...params
    })
    .get()
    .json();
}

export function fetchRelatedStories(story = {}) {
  const sectionId = get(story, ["sections", 0, "id"], 0);
  return global
    .wretch(`/api/v1/stories/${story.id}/related-stories`)
    .query({
      "section-id": sectionId,
      fields: FIELDS_FOR_LISTING_PAGE
    })
    .get()
    .json(response => response["related-stories"]);
}

export function hasStoryAccess(storyId) {
  return global
    .wretch(`/api/vikatan/v1/stories/${storyId}/access`)
    .get()
    .json()
    .catch(error => {
      console.error(error);
      return { granted: false };
    });
}

export function hasCollectionAccess(collectionId) {
  return global
    .wretch(`/api/vikatan/v1/collections/${collectionId}/access`)
    .get()
    .json()
    .catch(error => {
      console.error(error);
      return { granted: false };
    });
}

export function fetchLoggedInUser() {
  return global
    .wretch("/api/vikatan/v1/users/me")
    .get()
    .json(response => response.user);
}

export function incrementPremiumStoriesRead(storyIds) {
  if (Array.isArray(storyIds)) {
    return global.wretch("/api/vikatan/v1/stories/pingback").post({ storyIds });
  }
  if (typeof storyIds === "string") {
    return global.wretch(`/api/vikatan/v1/stories/${storyIds}/pingback`).post();
  }
}

export function fetchStoryAttributes(story) {
  return global
    .wretch(`/api/v1/stories/${story.id}/attributes`)
    .get(response => response.collections)
    .json();
}

export function fetchAuthorDetails(story) {
  const authorId = get(story, ["authors", 0, "id"]);
  return global
    .wretch(`/api/v1/authors/${authorId}`)
    .get()
    .json(response => response.author);
}
